import {Directive, Output, EventEmitter, HostListener, ElementRef, Renderer2} from '@angular/core';

@Directive({
  selector: '[appPasteFileDirective]'
})
export class PasteFileDirective {

  @Output()
  filePaste = new EventEmitter<File[]>();

  filePasteListener = null;

  constructor(
    protected hostEl: ElementRef,
    protected renderer: Renderer2
  ) {
    this.filePasteListener = (event: ClipboardEvent) => {
      this.onFilePaste(event)
    }
  }

  @HostListener('focusin', ['$event'])
  textAreaIsFocused() {
    document.addEventListener('paste', this.filePasteListener);
  }

  @HostListener('focusout', ['$event'])
  textAreaIsUnFocused() {
    document.removeEventListener('paste', this.filePasteListener);
  }

  @HostListener('drop', ['$event'])
  onDragEnter(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.filePaste.emit(files)
    }
  }

  onFilePaste(event: ClipboardEvent) {
    const items = (event.clipboardData).items;
    // tslint:disable-next-line: forin
    for (const index in items) {
      const item = items[index];
      if (item.kind === 'file') {
        const file = item.getAsFile();

        this.filePaste.emit([file])
      }
    }
  }
}
